module.exports = __webpack_public_path__ + "media/banners/plyny-menu-01b22f46.png";